import { Divider } from '@advanza/ui'
import AnonymizedRequestFilter from 'components/marketing/anonymizedRequests/AnonymizedRequestFilter'
import AnonymizedRequestsList from 'components/marketing/anonymizedRequests/AnonymizedRequestsList'
import Page from 'components/ui/Page'

const AnonymizedRequestsPage = () => {
    return (
        <Page title="Anonymized Requests">
            <h1>Anonymised Requests</h1>
            <Divider l />
            <AnonymizedRequestFilter filterId="all" defaultOptions={{ pageSize: 20 }} />
            <Divider m />
            <AnonymizedRequestsList filterId="all" />
        </Page>
    )
}

export default AnonymizedRequestsPage
